<template>
  <v-form>
    <v-container fluid>
      <v-row v-if="!initproduct">
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="productSelectItems"
            v-model="item.product"
            :items="productSelectItems"
            :error-messages="productErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.qualitycheck.product')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12"></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('qualitycheck.qualitycheck.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="userTestingSelectItems"
            v-model="item.userTesting"
            :items="userTestingSelectItems"
            :error-messages="userTestingErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.qualitycheck.usertesting')"
            item-text="login"
            item-value="@id"
            small-chips
          />
        </v-col>
      </v-row>



      <v-row>
        <!-- todo : fix the dateTime format, not supported by default on vuetify -->
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.start"
            :label="$t('qualitycheck.qualitycheck.start')"
            :error-messages="startErrors"
          />
        </v-col>
        <!-- todo : fix the dateTime format, not supported by default on vuetify -->
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.end"
            :label="$t('qualitycheck.qualitycheck.end')"
            :error-messages="endErrors"

          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-textarea
            v-model="item.comment"
            :error-messages="commentErrors"
            :label="$t('qualitycheck.qualitycheck.comment')"
            auto-grow
            rows="1"
            row-height="15"
            @input="$v.item.comment.$touch()"
            @blur="$v.item.comment.$touch()"
          />
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import InputDate from '../InputDate';
import Loading from '../../components/Loading';

export default {
  name: 'QualityCheckForm',
  mixins: [validationMixin],
  components: {
    InputDate,
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    initproduct: {
      type: String,
      required: false
    },
    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.userTestingGetSelectItems({'orderCol'  : 'order[login]','order'  : 'asc'});
      this.productGetSelectItems();
  },
  data() {
    return {
        name: null,
        comment: null,
        userTesting: null,
        start: null,
        end: null,
        product: null,
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_user ||
           this.isLoading_product
         );
      },
      ...mapFields('user', {
        userTestingSelectItems: 'selectItems',
        isLoading_user : 'isLoading'
      }),
      ...mapFields('product', {
        productSelectItems: 'selectItems',
        isLoading_product : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);


      return errors;
    },
    userTestingErrors() {
      const errors = [];

      if (!this.$v.item.userTesting.$dirty) return errors;

      has(this.violations, 'userTesting') && errors.push(this.violations.userTesting);


      return errors;
    },
    startErrors() {
      const errors = [];

      if (!this.$v.item.start.$dirty) return errors;

      has(this.violations, 'start') && errors.push(this.violations.start);


      return errors;
    },
    endErrors() {
      const errors = [];
      if (!this.$v.item.end.$dirty) return errors;

      has(this.violations, 'end') && errors.push(this.violations.end);


      return errors;
    },
    productErrors() {
      const errors = [];

      if (!this.$v.item.product.$dirty) return errors;

      has(this.violations, 'product') && errors.push(this.violations.product);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        userTestingGetSelectItems: 'user/fetchSelectItems'
      }),
      ...mapActions({
        productGetSelectItems: 'product/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      name: {
        required,
      },
      comment: {
      },
      userTesting: {
      },
      start: {

      },
      end: {

      },
      product: {
      },
    }
  }
};
</script>
